<div class="container">
    <div class="row align-items-center">
        <div class="col-lg-6">
            <div class="overview-content">
                <h3>{{'questowner_heading' | translate}}</h3>
                <div class="bar"></div>
                <p>{{'questowner_content' | translate}}</p>
                <div class="overview-btn">
                    <a routerLink="/" class="default-btn">{{'btn_gonow' | translate}} <span></span></a>
                </div>
            </div>
        </div>

        <div class="col-lg-6">
            <div class="overview-image">
                <!-- <img src="assets/img/overview.png" alt="image"> -->
                <img src="assets/img/QO1.png" alt="image">
            </div>
        </div>
    </div>
</div>
